import React, {Fragment} from 'react';
import ReactPlayer from 'react-player';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';

@observer
class TrackedVideoPlayer extends React.Component {
  @observable displayPlaceholder = false;
  @observable playing = false;

  @action playAndHidePlaceholder = () => {
    this.playing = true;
    this.displayPlaceholder = false;
  }

  constructor(props) {
    super(props);
    this.resetTracking();
    this.reactPlayer = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.url != this.props.url) {
      this.resetTracking();
    }
  }

  @action
  componentDidMount() {
    this.displayPlaceholder = this.props.displayPlaceholder;

    if(window.reactPlayers == undefined) window.reactPlayers = [];
    window.reactPlayers.push(this.reactPlayer.current);
  }

  resetTracking = () => {
    this.progressEventCount = 0;
    this.currentVideo25PercentPlayTracked = false;
    this.currentVideo50PercentPlayTracked = false;
    this.currentVideo90PercentPlayTracked = false;
  };

  trackVideoEvent = (eventName) => {
    if(this.props.serverSideTracking) {
      $.ajax({
        data: {
          video_tracking_event: {
            donation_form_id: this.props.videoTrackingEventProperties.donationFormId,
            name: eventName,
            url: window.location.href,
            user_id: this.props.videoTrackingEventProperties.userId,
            video_id: this.props.videoTrackingEventProperties.videoId,
            video_title: this.props.videoTrackingEventProperties.name,
          },
        },
        dataType: 'json',
        method: 'POST',
        url: '/api/v1/video_tracking_events',
      });
    }
  };

  onStart = () => {
    const eventName = 'Played Video';

    this.trackVideoEvent(eventName);
    window.analytics.track(eventName, this.props.videoTrackingEventProperties);

    if(typeof(this.props.onStart) == 'function') {
      this.props.onStart();
    }
  };

  onProgress = (event) => {
    // ignore first couple of events, they may be from previous video.
    if(this.progressEventCount > 2) {
      this.track25PercentPlay(event);
      this.track50PercentPlay(event);
      this.track90PercentPlay(event);

      if(typeof(this.props.onProgress) == 'function') {
        this.props.onProgress(event);
      }
    }

    this.progressEventCount += 1;
  };

  track25PercentPlay = (event) => {
    if(event.played > .25) {
      if(!this.currentVideo25PercentPlayTracked) {
        const eventName = 'Progressed in Video to 25%';
        this.currentVideo25PercentPlayTracked = true;

        this.trackVideoEvent(eventName);
        window.analytics.track(eventName, this.props.videoTrackingEventProperties);
      }
    }
  };

  track50PercentPlay = (event) => {
    if(event.played > .5) {
      if(!this.currentVideo50PercentPlayTracked) {
        const eventName = 'Progressed in Video to 50%';
        this.currentVideo50PercentPlayTracked = true;

        this.trackVideoEvent(eventName);
        window.analytics.track(eventName, this.props.videoTrackingEventProperties);
      }
    }
  };

  track90PercentPlay = (event) => {
    if(event.played > .9) {
      if(!this.currentVideo90PercentPlayTracked) {
        const eventName = 'Progressed in Video to 90%';
        this.currentVideo90PercentPlayTracked = true;

        this.trackVideoEvent(eventName);
        window.analytics.track(eventName, this.props.videoTrackingEventProperties);
      }
    }
  };

  onEnded = () => {
    const eventName = 'Finished Video';

    this.trackVideoEvent(eventName);
    window.analytics.track(eventName, this.props.videoTrackingEventProperties);

    if(typeof(this.props.onEnded) == 'function') {
      this.props.onEnded();
    }
  };

  render() {
    const {
      placeholderText,
      displayPlaceholder,
      serverSideTracking,
      videoTrackingEventProperties,
      ...reactPlayerProps
    } = this.props;
    reactPlayerProps.onStart = this.onStart;
    reactPlayerProps.onEnded = this.onEnded;
    reactPlayerProps.onProgress = this.onProgress;
    reactPlayerProps.playing = this.playing;

    return(
      <Fragment>
        <ReactPlayer
          {...reactPlayerProps}
          controls={true}
          ref={this.reactPlayer}
        />
        {this.displayPlaceholder &&
          <div
            className='placeholder'
            onClick={this.playAndHidePlaceholder}
          >
            <a className='play'>
              <span className='play-button content'>
                <span className='icn cw-icon-play' />
                <span className='text'>
                  {placeholderText}
                </span>
              </span>
            </a>
          </div>
        }
      </Fragment>
    );
  }
}

export default TrackedVideoPlayer;
